import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const enquiryFormManagementRoutes: RouteConfig[] = [
  {
    path: "/enquiryFormManagement",
    component: Layout,
    name: "EnquiryFormManagement",
    meta: {
      title: "enquiryFormManagement",
      icon: "el-icon-info",
      alwaysShow: true,
    },
    children: [
      {
        path: "/formUploadTool",
        component: () =>
          import(
            "@/views-oms/asking-for-quotation-management/FormUploadTool.vue"
          ),
        name: "EnquiryFormManagement",
        meta: { title: "formUploadTool" },
      },
      {
        path: "/taskManagement",
        component: () =>
          import(
            "@/views-oms/asking-for-quotation-management/TaskManagement.vue"
          ),
        name: "TaskManagement",
        meta: { title: "taskManagement" },
      },
    ],
  },
];

export default enquiryFormManagementRoutes;
